import { render, staticRenderFns } from "./editClass.vue?vue&type=template&id=106cf304&scoped=true"
import script from "./editClass.vue?vue&type=script&lang=js"
export * from "./editClass.vue?vue&type=script&lang=js"
import style0 from "./editClass.vue?vue&type=style&index=0&id=106cf304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cf304",
  null
  
)

export default component.exports